import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ExpenseList } from "../components/ExpenseList";
import { Card, Input, PageHeader, Stat } from "../components/ui";
import { api, errMsg } from "../lib/api";
import { FUNDING_ROLES, useAuth } from "../lib/auth";
import { fmtIDR, todayStr } from "../lib/format";

const CATS: Record<string, string> = { opex: "Expenses (OPEX)", shu: "SHU", interest: "Interest", dev: "Pengembangan Koperasi", npl_reserve: "Cadangan NPL" };

export default function Expenses() {
  const { can } = useAuth();
  const [params, setParams] = useSearchParams();
  const month = params.get("month") || todayStr().slice(0, 7);
  const [rows, setRows] = useState<any[]>([]);
  const load = useCallback(() => api.get("/cashflow/expenses", { params: { month } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), [month]);
  useEffect(() => { load(); }, [load]);
  const total = rows.reduce((a, r) => a + r.amount, 0);
  return (
    <div className="space-y-5" data-testid="expenses-page">
      <PageHeader title="Pengeluaran Koperasi" subtitle="Expenses · SHU · Interest · Pengembangan · Cadangan NPL — mengurangi saldo kas, tidak menyentuh cicilan siswa"
        actions={<Input data-testid="expenses-month" type="month" value={month} onChange={(e) => setParams({ month: e.target.value })} className="w-40" />} />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3">
        <Stat testId="exp-total" label={`Total ${month}`} value={fmtIDR(total)} hint={`${rows.length} transaksi`} tone="amber" />
        {Object.entries(CATS).map(([k, v]) => <Stat key={k} testId={`exp-cat-${k}`} label={v} value={fmtIDR(rows.filter((r) => r.category === k).reduce((a, r) => a + r.amount, 0))} />)}
      </div>
      <Card><ExpenseList rows={rows} cats={CATS} month={month} canEdit={can(FUNDING_ROLES)} onDone={load} /></Card>
    </div>
  );
}
